const BASE_URL = '/api/border-control';

const USERS_BASE_URL = '/users';
const AUTH_BASE_URL = '/auth';

export const borderControlUrls = {
  users: {
    profile: `${USERS_BASE_URL}/profile`,
    leads: `${USERS_BASE_URL}/leads`,
    savedSearches: `${USERS_BASE_URL}/saved-searches`,
    abandonedCheckout: `${USERS_BASE_URL}/abandoned-checkout`,
    orders: `${USERS_BASE_URL}/orders`,
    recentlyViewed: `${USERS_BASE_URL}/recently-viewed`,
  },
  auth: {
    changePassword: `${AUTH_BASE_URL}/change-password`,
    deleteAccount: `${AUTH_BASE_URL}/delete-account`,
    forgotPassword: `${AUTH_BASE_URL}/forgot-password`,
    resetPassword: `${AUTH_BASE_URL}/reset-password`,
    reVerifyEmail: `${AUTH_BASE_URL}/re-verify-email`,
    signup: `${AUTH_BASE_URL}/signup`,
    login: `${AUTH_BASE_URL}/login`,
  },
} as const;

export const borderControlApiUrls = {
  users: {
    profile: `${BASE_URL}${borderControlUrls.users.profile}`,
    leads: `${BASE_URL}${borderControlUrls.users.leads}`,
    savedSearches: `${BASE_URL}${borderControlUrls.users.savedSearches}`,
    abandonedCheckout: `${BASE_URL}${borderControlUrls.users.abandonedCheckout}`,
    orders: `${BASE_URL}${borderControlUrls.users.orders}`,
    recentlyViewed: `${BASE_URL}${borderControlUrls.users.recentlyViewed}`,
  },
  auth: {
    changePassword: `${BASE_URL}${borderControlUrls.auth.changePassword}`,
    deleteAccount: `${BASE_URL}${borderControlUrls.auth.deleteAccount}`,
    forgotPassword: `${BASE_URL}${borderControlUrls.auth.forgotPassword}`,
    resetPassword: `${BASE_URL}${borderControlUrls.auth.resetPassword}`,
    reVerifyEmail: `${BASE_URL}${borderControlUrls.auth.reVerifyEmail}`,
    signup: `${BASE_URL}${borderControlUrls.auth.signup}`,
    login: `${BASE_URL}${borderControlUrls.auth.login}`,
  },
};

export type BorderControlUrl =
  | (typeof borderControlUrls.users)[keyof typeof borderControlUrls.users]
  | (typeof borderControlUrls.auth)[keyof typeof borderControlUrls.auth];
